import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IFrameworkResource } from "../types";

export type IFrameworkDeleteMutationParameters = {
    framework: RelationalValue<IFrameworkResource>;
};

export type IFrameworkDeleteMutationResult = void;

export const frameworkDeleteMutation: IApiMutationFunction<IFrameworkDeleteMutationParameters> = ({ framework }) => {
    return {
        method: "DELETE",
        url: `/frameworks/${mapRelationalValue(framework)}`,
    };
};

export const useFrameworkDeleteMutation = createApiMutationHook<
    IFrameworkDeleteMutationParameters,
    IFrameworkDeleteMutationResult
>(frameworkDeleteMutation);
